import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Router, { getUrlWithUtmParams } from '@/components/common/router';
import { useDispatch, useSelector } from 'react-redux';
import CarIcon from '@/assets/Icons/car-header.svg';

import { resolvePath } from 'Utils/resolvePath';
import { IVehicleDetails } from 'Types/index';

import { ROUTEMAP, CarMakeImagesMap } from '../../constants';
import {
    fetchVehicleDetails,
    checkCarIsServiceable,
    createVehicle,
} from '../../api';
import NewAssetModal from '../NewAssetModal';
import SavedAssetModal from '../SavedAssetModal';
import {
    trackEventAPI,
    trackGTMEvent,
    viewPageAPI,
} from '@/analytics/middleware';
import {
    VIEW_PAGE_CAR_DETAILS_MODAL,
    TAP_BTN_ASSET_ICON,
} from '@/analytics/events';
import useQueryParam from '@/hooks/useQueryParam';
import { RedirectFrom } from '../../constants';
import NotServiceableModal from '../notServiceableModal';
import { generateMmvData, getMMVDetails, getUniqueObjects } from '../../utils';
import {
    selectVehicleInfo,
    setVehicleInfo,
} from '@/store/modules/savedVehicleSlice';
import EvBlockModal from '../evBlockModal';
import { EV, ELECTRIC } from '@/constants/common';
import { redirectToLandingPage } from '@/utils/common';
export interface IServices {
    title: string;
    price: string;
    list: string[];
}

interface Pricing {
    base_amount: string;
    discount_value: string;
    discount_percent: string;
    discounted_amount: string;
}
interface ADServicesComponentProps {
    isMobile?: boolean;
    vehicleData?: IVehicleDetails;
    savedAssetData?: Array<IVehicleDetails>;
    isLoadingData?: boolean;
    vehicleNumber?: string;
    saveBookingData: (data: any, mmData: any) => void;
    editCarModal: boolean;
    assetModalClose: () => void;
    children?: React.ReactElement | React.ReactElement[];
}

const defaultPricing = {
    base_amount: '0',
    discount_value: '0',
    discount_percent: '0',
    discounted_amount: '0',
};

export function useGarageId(): string | undefined {
    const router = useRouter();
    const [garageId, setGarageId] = useState<string | undefined>();

    useEffect(() => {
        const fromQuery = router.query.garageId;
        const fromStorage = localStorage.getItem('garage_id');

        const resolvedGarageId =
            typeof fromQuery === 'string'
                ? fromQuery
                : fromStorage || undefined;

        setGarageId(resolvedGarageId);
    }, [router.query.garageId]);

    return garageId;
}
export default function VehicleAssetWrapper(props: ADServicesComponentProps) {
    const dispatch = useDispatch();
    const vehicleNumber = useQueryParam('vehicleNumber') || '';
    const {
        savedAssets: savedAssetData,
        vehicleDetails,
        carNumber,
        hasSavedVehicle,
    } = useSelector(selectVehicleInfo);

    const {
        vehicleData,
        saveBookingData,
        isLoadingData,
        //savedAssetData = [],
        editCarModal,
        assetModalClose,
        children,
    } = props;
    const garageId = useGarageId();
    console.log({ saveBookingData, editCarModal });

    const router = useRouter();

    const isMobile = true;
    const {
        vehicle_id,
        fuel_type,
        loggedin,
        redirect_from = '',
        carnumber,
        is_new_flow = false,
    } = router.query;

    const initialModalState = {
        serviceModal: false,
        showNewAssetModal: false,
        showSavedAssetModal: false,
        showEligibilityModal: false,
        showCarDetailsNotFoundModal: false,
        showEditCarModal: false,
        showEvBlockModal: Boolean(router.query.newCar),
    };

    const [modalState, setModalState] = useState(initialModalState);
    const [pricing, setPricing] = useState<Pricing>(defaultPricing);
    const [savedAssets, setSavedAssets] = useState<IVehicleDetails[]>([]);
    const [mmv, setMmv] = useState({
        make: '',
        model: '',
        model_id: 0,
        fuel_type: '',
        car_age: 0,
    });
    const [evModalData, setEvModalData] = useState<IVehicleDetails>({
        vehicle_make: '',
        vehicle_model: '',
        vehicle_number: '',
        fuel_type: '',
        variant_name: '',
    });
    const isAssetSelected = vehicleNumber;
    console.log('debug2', savedAssetData, savedAssets);

    useEffect(() => {
        if (Array.isArray(savedAssetData) && savedAssetData.length > 0) {
            console.log('debug22', savedAssetData);

            setSavedAssets((prevAssets) =>
                getUniqueObjects(
                    [...savedAssetData, ...prevAssets],
                    'vehicle_number'
                )
            );
        }
    }, [savedAssetData]);

    useEffect(() => {
        console.log('is loading data', isLoadingData);
        if (router.query.newCar) {
            console.log('New asset modal :: new car');
            openModal('showNewAssetModal');
            modalState.showNewAssetModal = true;
            console.log(
                'modalState.showNewAssetModal :: ',
                modalState.showNewAssetModal
            );
        } else if (editCarModal) {
            openModal('showSavedAssetModal');
        } else {
            closeAllModals();
        }
    }, [editCarModal, router.query.newCar]);

    useEffect(() => {
        // if (redirect_from === RedirectFrom.PRICING_PLAN) {
        //     closeModal('showSavedAssetModal');
        //     return;
        // }
        if (router.query.newCar) return;
        if (loggedin && Array.isArray(savedAssetData) && !editCarModal) {
            onClickCTA();
            return;
        }
    }, [savedAssetData]);

    const onClickCTA = () => {
        if (isAssetSelected) {
            Router.push({
                pathname: router.pathname + '/choose-location',
                query: {
                    vehicleNumber,
                    redirect_from,
                },
            });
        } else if (savedAssetData && savedAssetData.length > 0) {
            closeModal('showEligibilityModal');
            openModal('showSavedAssetModal');
            viewPageAPI({
                event_name: VIEW_PAGE_CAR_DETAILS_MODAL,
                customAttributes: {
                    adsc_asset_saved: savedAssets.length > 0,
                },
                isFakeDoor: true,
            });
        } else {
            openModal('showCarDetailsNotFoundModal');
        }
    };

    const fetchAndProcessVehicleDetails = async (vehicleNumber: string) => {
        const res = await fetchVehicleDetails(vehicleNumber);

        if (!res?.car_details) {
            if (res?.error !== 'invalid_vehicle') {
                throw new Error('Car details not found');
            }
            console.log('Invalid vehicle:', res?.error);
            return { res, mmvData: null };
        }
        const mmvData = generateMmvData(res.car_details);
        return { res, mmvData };
    };

    const checkServiceability = async (makeName: string) => {
        const currentGarageId = garageId || localStorage.getItem('garage_id');
        const isCarServiceable = await checkCarIsServiceable(
            currentGarageId as string,
            makeName
        );
        if (!isCarServiceable) {
            throw new Error('Car not serviceable');
        }
    };

    const handleRedirect = (vehicleNumber: string, redirectFrom?: string) => {
        if (redirectFrom === RedirectFrom.PERIODIC_SERVICE) {
            const route = `${ROUTEMAP.GARAGE_PRICING_PLANS}?loggedin=true&redirect_from=periodic&carnumber=${vehicleNumber || ''}&garageId=${garageId}`;
            Router.replace(route);
            return;
        }
        if (redirectFrom === RedirectFrom.PRICECHECK_CTA) {
            Router.replace(
                `${ROUTEMAP.GARAGE_PRICING_PLANS}?carnumber=${vehicleNumber || ''}&garageId=${garageId}`
            );
        } else if (redirectFrom === RedirectFrom.SPECIFIC_REPAIR) {
            Router.replace(
                `${ROUTEMAP.GARAGE_PICK_DROP}?redirect_from=${RedirectFrom.SPECIFIC_REPAIR}&carnumber=${vehicleNumber || ''}&garageId=${garageId}`
            );
        } else if (redirectFrom === RedirectFrom.SR_PRICECHECK_CTA) {
            Router.replace(
                `${ROUTEMAP.GARAGE_SPECIFIC_REPAIR}?redirect_from=${RedirectFrom.SR_PRICECHECK_CTA}&carnumber=${vehicleNumber || ''}&garageId=${garageId}`
            );
        } else if (redirectFrom === RedirectFrom.GET_CAR_TO_GARAGE) {
            Router.replace(
                `${ROUTEMAP.GARAGE_PICK_DROP}?redirect_from=${redirectFrom}&carnumber=${vehicleNumber || ''}&garageId=${garageId}`
            );
        } else if (redirectFrom === RedirectFrom.NOT_SURE_ABOUT_THE_ISSUE) {
            Router.replace(
                `${ROUTEMAP.GARAGE_HELP_PAGE}?redirect_from=unknown-issue&carnumber=${vehicleNumber || ''}&garageId=${garageId}`
            );
        } else if (redirectFrom === RedirectFrom.CAR_SPA_AND_CLEANING) {
            Router.replace(
                `${ROUTEMAP.GARAGE_PICK_DROP}?redirect_from=${redirectFrom}&carnumber=${vehicleNumber || ''}&garageId=${garageId}`
            );
        } else if (redirectFrom === RedirectFrom.WHEEL_ALIGNMENT) {
            Router.replace(
                `${ROUTEMAP.GARAGE_PICK_DROP}?redirect_from=${redirectFrom}&carnumber=${vehicleNumber || ''}&garageId=${garageId}`
            );
        } else {
            // router.push(
            //     `${ROUTEMAP.MMV}?redirect_from=${redirectFrom || RedirectFrom.V2_FLOW}&carnumber=${vehicleNumber || ''}`
            // );
        }
    };

    const savedAssetClick = async (asset: any) => {
        console.log('debug', asset.vehicle_number);

        const currentAsset = carNumber;
        if (asset.vehicle_number || currentAsset) {
            trackGTMEvent('confirm_car_details', {
                registration_number: asset.vehicle_number,
            });
        }
        if (currentAsset === asset.vehicle_number && editCarModal) {
            closeModal('showSavedAssetModal');
            assetModalClose();
            return;
        }

        sessionStorage.setItem('registration_number', asset.vehicle_number);
        createVehicle(asset.vehicle_number);
        try {
            const { res, mmvData } = await fetchAndProcessVehicleDetails(
                asset.vehicle_number
            );

            const fuelType = res?.car_details?.fuel_type;
            if (
                redirect_from === RedirectFrom.PERIODIC_SERVICE &&
                (fuelType?.toUpperCase() === EV ||
                    fuelType?.toUpperCase() === ELECTRIC)
            ) {
                setEvModalData({
                    ...asset,
                    fuel_type: fuelType,
                    vehicle_make: mmvData?.make || asset?.vehicle_make,
                    vehicle_model: mmvData?.model || asset?.vehicle_model,
                    variant_name: mmvData?.variant || asset?.variant_name,
                });
                openModal('showEvBlockModal');
                return;
            }

            if (mmvData) {
                setMmv(mmvData);
                sessionStorage.setItem('mmv', JSON.stringify(mmvData));
            }

            if (redirect_from !== RedirectFrom.CAR_SPA_AND_CLEANING) {
                await checkServiceability(res.car_details.make_name);
            }

            saveBookingData(asset.vehicle_number, mmvData);
            localStorage.setItem('mmv', JSON.stringify(mmvData));

            let mmvsData = JSON.parse(localStorage.getItem('mmvsData') || '{}');

            mmvsData[asset.vehicle_number] = mmvData;
            localStorage.setItem('mmvsData', JSON.stringify(mmvsData));

            localStorage.setItem('registration_number', asset.vehicle_number);

            closeModal('showSavedAssetModal');
            editCarModal && assetModalClose();
            handleRedirect(asset.vehicle_number, redirect_from as string);
        } catch (error: any) {
            if (error.message === 'Car details not found') {
                //openModal('showCarDetailsNotFoundModal');
                Router.push(
                    `${ROUTEMAP.MMV}?redirect_from=${redirect_from || RedirectFrom.V2_FLOW}&carnumber=${asset.vehicle_number || ''}&garageId=${garageId}`
                );
            } else if (error.message === 'Car not serviceable') {
                openModal('showEligibilityModal');
                //toast.error('Car not serviceable');
            }
        }
    };

    const newAssetHandler = async (inputs: string) => {
        sessionStorage.setItem('registration_number', inputs);
        const garageId = localStorage.getItem('garage_id');
        try {
            const { res, mmvData } =
                await fetchAndProcessVehicleDetails(inputs);
            if (mmvData === null) {
                return 'Invalid vehicle';
            }

            const newVehicle = {
                vehicle_number: inputs,
                vehicle_make: res.car_details.make_name,
                vehicle_model: res.car_details.model_name,
                variant_name: res.car_details.variant_name,
                fuel_type: res.car_details.fuel_type,
                model_id: res.car_details.acko_model_id,
                color: res.car_details.color,
                photo: res.photos?.url,
                isVISData: false, // TODO: why this is true
            };
            setSavedAssets((prevAssets) =>
                getUniqueObjects([newVehicle, ...prevAssets], 'vehicle_number')
            );

            if (redirect_from !== RedirectFrom.CAR_SPA_AND_CLEANING) {
                await checkServiceability(res.car_details.make_name);
            }

            closeModal('showNewAssetModal');
            sessionStorage.setItem('vehicleModalAutoOpened', 'true');

            openModal('showSavedAssetModal');
        } catch (error: any) {
            trackGTMEvent('confirm_car_details', {
                registration_number: inputs,
            });
            localStorage.setItem('registration_number', inputs);

            if (error.message === 'Car details not found') {
                Router.push(
                    `${ROUTEMAP.MMV}?redirect_from=${redirect_from || RedirectFrom.V2_FLOW}&carnumber=${inputs || ''}&garageId=${garageId}`
                );
            } else if (error.message === 'Car not serviceable') {
                openModal('showEligibilityModal');
                //toast.error('Car not serviceable');
            }
        }
    };

    const addNewAssetClick = () => {
        if (savedAssets[0]?.isVISData)
            Router.push(
                `${ROUTEMAP.MMV}?redirect_from=${RedirectFrom.V2_FLOW}`
            );
        else {
            closeModal('showSavedAssetModal');
            openModal('showNewAssetModal');
        }
    };

    const openModal = (modal: keyof typeof modalState) => {
        // Set all modals to false first
        const updatedModalState = Object.keys(modalState).reduce(
            (acc, key) => {
                acc[key as keyof typeof modalState] = false;
                return acc;
            },
            {} as typeof modalState
        );

        // Set the specified modal to true
        setModalState({ ...updatedModalState, [modal]: true });
    };
    const closeModal = (modal: keyof typeof modalState) =>
        setModalState({ ...modalState, [modal]: false });
    const closeAllModals = () => {
        setModalState(initialModalState);
    };

    const hasModalBeenAutoOpened = () => {
        return sessionStorage.getItem('vehicleModalAutoOpened') === 'true';
    };

    console.log(
        'debug-stae',
        savedAssets,
        editCarModal,
        hasSavedVehicle,
        isLoadingData
    );
    console.log('test', modalState, savedAssets, garageId);
    // const isCTADisabled =
    //     ctaName === 'Check price' && (isCheckingLocationAcess || modalActive);
    const handleHomeBack = () => {
        redirectToLandingPage();
    };

    const handleAddCar = () => {
        closeModal('showEvBlockModal');
        openModal('showNewAssetModal');
    };

    const carData = {
        vehicle_make: vehicleDetails?.make,
        vehicle_model: vehicleDetails?.model,
        model_id: vehicleDetails?.model_id,
        vehicle_number:
            localStorage.getItem('registration_number') || undefined,
        fuel_type: (() => {
            const fuelType = vehicleDetails?.fuel_type?.toUpperCase();
            return fuelType === 'EV' || fuelType === 'ELECTRIC'
                ? fuelType
                : 'EV';
        })(),
        varient: vehicleDetails?.variant_name,
    };
    return (
        <>
            {children}
            {isLoadingData && (
                <>
                    {savedAssets.length > 0 && (
                        <SavedAssetModal
                            show={modalState.showSavedAssetModal}
                            savedAssets={savedAssets}
                            //close={closeSavedAssetModal}
                            //close={() => closeModal('showSavedAssetModal')}
                            close={assetModalClose}
                            savedAssetClickHandler={savedAssetClick}
                            addNewAssetClick={addNewAssetClick}
                            isNewBookingFlow={true}
                            editCarModal={
                                editCarModal && hasModalBeenAutoOpened()
                            }
                        />
                    )}

                    {(modalState.showNewAssetModal ||
                        modalState.showCarDetailsNotFoundModal) && (
                        <NewAssetModal
                            show={
                                modalState.showNewAssetModal ||
                                modalState.showCarDetailsNotFoundModal
                            }
                            close={assetModalClose}
                            newAssetHandler={newAssetHandler}
                            isNew={modalState.showNewAssetModal}
                        />
                    )}
                    <NotServiceableModal
                        show={modalState.showEligibilityModal}
                        close={() => {
                            closeModal('showEligibilityModal');
                            setPricing(defaultPricing);
                        }}
                        clickHandler={addNewAssetClick}
                        isNewFlow
                        editCarModal={editCarModal}
                        make={mmv.make || ''}
                    />
                    {modalState.showEvBlockModal && (
                        <EvBlockModal
                            show={modalState.showEvBlockModal}
                            close={() => {
                                closeModal('showEvBlockModal');
                            }}
                            clickCarHandler={handleAddCar}
                            clickHomeHandler={handleHomeBack}
                            carData={evModalData}
                        />
                    )}
                </>
            )}
        </>
    );
}

export const EditSavedAsset: React.FC<{
    carModel: string;
    color?: string;
    showCarEditModalOnFirstMount: boolean;
}> = ({ carModel = '', color, showCarEditModalOnFirstMount }) => {
    const dispatch = useDispatch();
    const router = useRouter();
    const { utm_medium = '', confirmation_modal = '' } = router.query;
    const isOpenConfirmationModal = useQueryParam('confirmation_modal') || '';

    const { savedAssets, vehicleDetails, carNumber } =
        useSelector(selectVehicleInfo);
    console.log(savedAssets, vehicleDetails, 'selected vehicle');

    const [isLoadingData, setIsLoadingData] = useState(false);
    const [editCarModal, setEditCarModal] = useState(false);
    const hasModalBeenAutoOpened = () => {
        return (
            sessionStorage.getItem('vehicleModalAutoOpened') === 'true' ||
            (typeof utm_medium === 'string' &&
                utm_medium?.toLowerCase() === 'whatsapp_campaign') ||
            confirmation_modal === 'false'
            //This is to disable auto open modal in case of whatsapp campaign
        );
    };

    const saveBookingData = (vehicleNumber: string, mmvData: any) => {
        // Logic to save booking data based on vehicle number
        console.log('Saving booking data for:', vehicleNumber);
        const savedData = {
            vehicle_make: mmvData?.make,
            vehicle_model: mmvData?.model,
            vehicle_name: '',
            vehicle_number: vehicleNumber,
        };
        dispatch(
            setVehicleInfo({
                carNumber: vehicleNumber,
                vehicleDetails: mmvData,
                hasSavedVehicle: true,
            })
        );
        //dispatch(setSavedAssets([savedData, ...savedAssets]));
    };
    const getIconFromMake = (make: string | undefined) => {
        if (make == null) return '';
        return CarMakeImagesMap[make] || '';
    };

    const assetModalClose = () => {
        // Logic to close the asset modal
        setEditCarModal(false);
        sessionStorage.setItem('vehicleModalAutoOpened', 'true');
    };

    const changeCar = () => {
        trackEventAPI({
            event_name: TAP_BTN_ASSET_ICON,
            customAttributes: {
                ...getMMVDetails(),
                saved_assets: localStorage.getItem('mmv') ? true : false,
            },
            isFakeDoor: true,
        });
        console.log('test', editCarModal);
        setEditCarModal(!editCarModal);
    };
    useEffect(() => {
        // Check if modal should auto-open
        // Conditions:
        // 1. Modal hasn't been auto-opened in this session
        // 2. Vehicle details exist
        // 3. User hasn't manually opened the modal
        if (
            showCarEditModalOnFirstMount &&
            !hasModalBeenAutoOpened() &&
            vehicleDetails &&
            !editCarModal
        ) {
            // Optional: Add more specific conditions if needed
            setEditCarModal(true);
        }
    }, [vehicleDetails]);
    return (
        <>
            <div className="car" onClick={changeCar}>
                {getIconFromMake(vehicleDetails?.make) !== '' ? (
                    <img
                        src={resolvePath(
                            getIconFromMake(vehicleDetails?.make) || ''
                        )}
                        width={15}
                        height={15}
                    />
                ) : (
                    <CarIcon />
                )}

                <span className="car-model">{carModel}</span>
            </div>

            <VehicleAssetWrapper
                saveBookingData={saveBookingData}
                isLoadingData={editCarModal}
                editCarModal={editCarModal}
                assetModalClose={assetModalClose}
            />

            <style jsx>{`
                .car {
                    display: flex;
                    cursor: pointer;
                    font-size: 12px;
                    font-weight: 400;
                    color: ${color};
                    align-items: center;
                    margin: 0 4px 0 4px;
                    gap: 2px;

                    .car-model {
                        max-width: 10ch;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            `}</style>
        </>
    );
};
